module.exports = __webpack_public_path__ + "static/media/ourstories-screen-girls-meals-kitchen.7b9f2e76.png";